<template>
  <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 lg:gap-16 text-start">
    <article v-for="award in awards" class="flex flex-col items-end justify-between bg-[#EAEFF0] px-5 py-8 rounded-lg">
      <div class="w-full">
        <div class="mb-5" :class="props.scope == 'media' ? 'h-10' : props.scope == 'partner' ? 'h-[50px]' : 'h-[50px]'">
          <NuxtImg
            v-if="award.logo?.permalink"
            loading="lazy"
            :src="award.logo.permalink"
            alt="show_title"
            class="object-contain object-left max-w-full max-h-full"
            Width="250"
            height="24"
          />
        </div>
        <div class="flex gap-2 mb-3 justify-between font-semibold">
          <h3 class="text-primary-100 text-xs">
            {{ award.organization_name }}
          </h3>
          <span :aria-label="$t('aboutUs.publishedAt')" class="text-[#21375680] text-xs" v-if="award.reference_date">
            {{ dayjs(award.reference_date).format("DD MMM YYYY") }}
          </span>
          <span
            :aria-label="$t('aboutUs.publishedAt')"
            class="text-[#21375680] text-xs"
            v-else-if="award.reference_year"
          >
            {{ award.reference_year }}
          </span>
        </div>
        <p class="font-bold">
          {{ award.title }}
        </p>
      </div>
      <NuxtLinkLocale
        :locale="switchBlogLocale()"
        v-if="award.reference_link?.url"
        class="text-secondary underline hover:no-underline flex flex-row flex-wrap gap-[1ch] mt-5 w-fit"
        :to="award.reference_link?.url"
        target="_blank"
      >
        <NuxtImg loading="lazy" src="/icons/launch-app.svg" alt="" class="align-middle" width="12" height="12" />
      </NuxtLinkLocale>
    </article>
  </div>
  <BaseButton
    v-if="canLoadMoreData"
    :text="$t('common.loadMore')"
    class="mt-10 md:mt-20 mx-auto min-w-[15rem]"
    variant="outlined"
    @buttonClicked="handleLoadMore"
    :loading="loadingAwards"
  />
</template>

<script setup lang="ts">
import type { AwardScope } from "~/entities/MediaAndAwardsEntities";
import dayjs from "dayjs";

export interface AwardsProps {
  scope: AwardScope;
}

const props = defineProps<AwardsProps>();

const currentPage = ref<number>(0);
const loadingAwards = ref<boolean>(false);

const canLoadMoreData = ref<boolean>(false);
const { data } = await loadAwardsList();
const awards = ref(data.value?.data ?? []);

async function loadAwardsList() {
  currentPage.value += 1;
  const awardsData = await useAwardsList(props.scope, currentPage.value);
  const metadata = awardsData.data.value.meta!;
  canLoadMoreData.value = metadata.current_page * metadata.per_page < metadata.total;

  return awardsData;
}

const handleLoadMore = () => {
  loadingAwards.value = true;
  usePendingState(
    async () => {
      const { data: moreData } = await loadAwardsList();
      awards.value = [...awards.value, ...(moreData.value.data ?? [])];
    },
    () => (loadingAwards.value = false)
  );
};
</script>
